module.exports = __webpack_public_path__ + "static/media/github.2ef81c65.svg";